import script from "./InvitesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitesTable.vue?vue&type=script&setup=true&lang=js"

import "./InvitesTable.vue?vue&type=style&index=0&id=25f35762&scoped=true&lang=css"
script.__scopeId = "data-v-25f35762"

export default script